import styled from 'styled-components';

export const NavigationTabsContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  .selected-sign-in > div:first-child {
    background-color: yellow;
  }
  .selected-create-account > div:last-child {
    background-color: red;
  }
`;

export const NavigationTab = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  border-bottom: 1px solid color-mix(in oklab, #1D1B26 20%, #0000);
  height: 2.5rem;
  font-family: "Figtree", ui-sans-serif, system-ui, -apple-system, "system-ui", "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-size: 14px;
  border-bottom: 2px solid #C8C6CA;
  a, a:visited {
    color: #69686F;
    text-decoration: none;
  };
  a:hover {
    color: #000000;
    text-decoration: none;
  }
`;

export const SelectedNavigationTab = styled(NavigationTab)`
  border-bottom: 4px solid #0300A4;
  color: #0300A4;
`;
